// catch all add to cart clicks
$("#productModal").on("click", ".atc-btn", function (e) {
  var data = e.target.getAttribute("data-serialized");
  window.theme.Product.prototype._addItemToCart(data);
});

var getProductJsonFromPage = function () {
  var productScriptObj = document.getElementById("productJson");
  if(!productScriptObj){
    return null;
  }
  var productScript = productScriptObj.innerHTML;
  var productJson = JSON.parse(productScript);
  return productJson
};

var setOverWriteCookie = function () {
  var doctorCookie = "pro_doctor";
  var doctorsOffice = window.location.pathname.replace("/pages/","").split("/")[0].split(/[?#]/)[0];
  var date = new Date();
  var days = 28;
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  var expires = "; expires=" + date.toGMTString();
  // set/overwrite the cookie
  document.cookie = doctorCookie + "=" + doctorsOffice + expires + "; path=/";
};

var writeModalHeadline = function (heading) {
  var headline = document.querySelectorAll(".top-content h2")[0];
  if (heading) {
    headline.innerText = heading;
  } else {
    headline.innerText = "Choose your hair growth journey:";
  }
}

var addMainImage = function (imgSrc, text) {
  var imgEl = document.getElementById("product-image");
  imgEl.src = imgSrc;
  imgEl.alt = text;
};

var createProductArea = function (divId, title, productExtraInfo) {
  var productArea = document.getElementById(divId);
  productArea.parentNode.classList.remove("single");
  const headingTitle = productExtraInfo.heading ? productExtraInfo.heading : title;
  productArea.innerHTML = "";
  if (productExtraInfo.text) {
    var productHtml = 
      "<div class='product-template__container page-width' id='ProductSection-product-template' data-section-id='product-template' data-section-type='product' data-enable-history-state='true' data-ajax-enabled='true'>" +
        "<h3>"+ headingTitle +"</h3>" +
        "<p class='subscription-info'>" + productExtraInfo.text + "</p>" +
        "<p class='pricing new'><span class='is-price'>"+ productExtraInfo.is_price +"</span><span class='savings'>"+ productExtraInfo.savings+"</span><span class='was-price'>"+ productExtraInfo.was_price +"</span></p>" +
        "<p class='dosage-info'>"+ productExtraInfo.contains +"</p>" +
        "<button class='btn btn--secondary atc-btn' data-serialized="+ productExtraInfo.dataSerialized +">Add to Cart</button>" +
      "</div>";
      productArea.innerHTML = productHtml;
  } else {
    productArea.parentNode.classList.add("single");
  }
};

var loadAndshowModal = function (e) {
  var el = e.target;
  var containerWithInfo = $(el).closest(".modal-button");
  var tripleProductId = containerWithInfo.attr("data-triple-id");
  var productJson = getProductJsonFromPage();
  var tripleInfo = productJson.products[tripleProductId];

  var extraProductInfo = {
    core: {
      oneTimeExtraInfo: {
        "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
        "text": "Three-month supply shipped once.",
        "is_price": "$237",
        "was_price": "List Price: $264",
        "savings": "",
        "contains": "DAILY DOSAGE: 4 CAPSULES"
      },
      subscriptionExtraInfo: {
        "dataSerialized": "form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id=" + tripleInfo.subscription_id + "&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=3&quantity=1",
        "text": "Three-month supply shipped every three months.",
        "is_price": "$209",
        "was_price": "List Price: $264",
        "savings": "(<b>Save $55</b> off list price)",
        "contains": "DAILY DOSAGE: 4 CAPSULES"
      },
    },
    booster: {
      "stress-adaptogen-propack-three-bottles": {
        heading: "Give your Nutrafol regimen a boost with extra stress support:",
        oneTimeExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
          "text": "Three-month supply shipped once.",
          "is_price": tripleInfo.price.split(".")[0],
          "was_price": "",
          "savings": "",
          "contains": "DAILY DOSAGE: 2 CAPSULES"
        },
        subscriptionExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id=" + tripleInfo.subscription_id + "&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=3&quantity=1",
          "text": "Three-month supply shipped every three months.",
          "is_price": "$78",
          "was_price": "",
          "savings": "(<b>Save $12</b>)",
          "contains": "DAILY DOSAGE: 2 CAPSULES"
        },
      },
      "hairbiotic-propack-three-bottles": {
        heading: "Give your Nutrafol regimen a boost with extra gut support:",
        oneTimeExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
          "text": "Three-month supply shipped once.",
          "is_price": tripleInfo.price.split(".")[0],
          "was_price": "",
          "savings": "",
          "contains": "DAILY DOSAGE: 1 CAPSULE"
        },
        subscriptionExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id=" + tripleInfo.subscription_id + "&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=3&quantity=1",
          "text": "Three-month supply shipped every three months.",
          "is_price": "$104",
          "was_price": "",
          "savings": "(<b>Save $16</b>)",
          "contains": "DAILY DOSAGE: 1 CAPSULE"
        },
      },

      "stress-adaptogen-md-propack-three-bottles": {
        heading: "Give your Nutrafol regimen a boost with extra stress support:",
        oneTimeExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
          "text": "Three-month supply shipped once.",
          "is_price": tripleInfo.price.split(".")[0],
          "was_price": "",
          "savings": "",
          "contains": "DAILY DOSAGE: 2 CAPSULES"
        },
        subscriptionExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id=" + tripleInfo.subscription_id + "&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=3&quantity=1",
          "text": "Three-month supply shipped every three months.",
          "is_price": "$100",
          "was_price": "",
          "savings": "(<b>Save $20</b>)",
          "contains": "DAILY DOSAGE: 2 CAPSULES"
        },
      },
      "hairbiotic-md-propack-three-bottles": {
        heading: "Give your Nutrafol regimen a boost with extra gut support:",
        oneTimeExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
          "text": "Three-month supply shipped once.",
          "is_price": tripleInfo.price.split(".")[0],
          "was_price": "",
          "savings": "",
          "contains": "DAILY DOSAGE: 1 CAPSULE"
        },
        subscriptionExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id=" + tripleInfo.subscription_id + "&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=3&quantity=1",
          "text": "Three-month supply shipped every three months.",
          "is_price": "$100",
          "was_price": "",
          "savings": "(<b>Save $20</b>)",
          "contains": "DAILY DOSAGE: 1 CAPSULE"
        },
      },

      "growth-serum": {
        heading: "Give your Nutrafol regimen a boost with this lightweight topical serum:",
        oneTimeExtraInfo: {
          "dataSerialized": "form_type=product&utf8=%E2%9C%93&purchase_type=onetime&id="+ tripleInfo.variant_id +"&quantity=1",
          "heading": "Single Bottle, Shipped Once",
          "text": " ",
          "is_price": tripleInfo.price.split(".")[0],
          "was_price": "",
          "savings": "",
          "contains": "USAGE: FOR BEST RESULTS USE TWICE PER DAY."
        },
        subscriptionExtraInfo: {},
      },
    }
  }

  var singleExtraInfo = extraProductInfo.booster[tripleInfo.handle] && extraProductInfo.booster[tripleInfo.handle].oneTimeExtraInfo ? extraProductInfo.booster[tripleInfo.handle].oneTimeExtraInfo : extraProductInfo.core.oneTimeExtraInfo;
  var subExtraInfo = extraProductInfo.booster[tripleInfo.handle] && extraProductInfo.booster[tripleInfo.handle].subscriptionExtraInfo ? extraProductInfo.booster[tripleInfo.handle].subscriptionExtraInfo : extraProductInfo.core.subscriptionExtraInfo;
  var isBooster = extraProductInfo.booster[tripleInfo.handle] && extraProductInfo.booster[tripleInfo.handle].oneTimeExtraInfo ? true : false;
  var customHeading = extraProductInfo.booster[tripleInfo.handle] && extraProductInfo.booster[tripleInfo.handle].heading ? extraProductInfo.booster[tripleInfo.handle].heading : null;
  // var boosterHeading = extraProductInfo.booster[tripleInfo.handle] && extraProductInfo.booster[tripleInfo.handle].oneTimeExtraInfo ? true : false;

  // create the product areas
  addMainImage(tripleInfo.image, tripleInfo.name);
  createProductArea("leftProduct", "Three-Month Purchase", singleExtraInfo, isBooster);
  createProductArea("rightProduct", "Auto-Subscription", subExtraInfo, isBooster);
  writeModalHeadline(customHeading)

  // scroll to top
  window.scrollTo(0,0);
 
  if (
    typeof(window) !== "undefined" && 
    typeof(window.analytics) !== "undefined" && 
    typeof(window.analytics.track) !== "undefined"
  ) {

    var imageUrl = tripleInfo.image;
    var name = tripleInfo.name;
    var productGender = name.indexOf("Men") > -1 ? "Men" : "Women";
    var url = window.location.href;
    var coreCategory = "";
    if (name.indexOf("Balance") > -1) {
      var coreCategory = "Balance";
    } else if (name.indexOf("Women") > -1) {
      var coreCategory = "Women";
    } else {
      var coreCategory = "Men";
    }

    window.analytics.track('Product Viewed', {
      core_category: coreCategory,
      image_url: imageUrl,
      name: name,
      product_gender: productGender,
      url: url
    });

  }

  // show the modal
  var slug = tripleInfo.handle;
  showModal(e, slug);
  
} 

var attachPopListener = function () {
  $(window).on("popstate", function() {
    hideModal();
  });
}

var removePopListener = function () {
  $(window).off("popstate");
}
 
var lastCharacterMatch = function (string, lastCharMatch) {
  var stringSplit = string.split("");
  var lastChar = stringSplit[stringSplit.length - 1];
  if (lastChar == lastCharMatch) {
    return true;
  }
  return false;
};

var addHashToURL = function(slug) {
  var currentPath = window.location.pathname;
  var newPath = lastCharacterMatch(currentPath, "/") ? currentPath + slug : currentPath + "/" + slug;
  history.pushState({ urlPath: newPath }, "", newPath);
}

var showModal = function (e, slug) {
  var modal = document.getElementById("productModal");
  var drWrap = document.querySelectorAll(".doctor-pg-wrap")[0];
  if (e.which) {
    // Actually clicked
    // console.log("triggered by user");
    addHashToURL(slug);
    attachPopListener();
  } else {
    // Triggered by code
    // console.log("triggered by code");
  }
  drWrap.classList.add("hide");
  modal.classList.add("show");
}

var hideModal = function () {
  // remove popstate listener
  removePopListener();

  var modal = document.getElementById("productModal");
  var drWrap = document.querySelectorAll(".doctor-pg-wrap")[0];
  drWrap.classList.remove("hide");
  modal.classList.remove("show");
}

var backButtonClick = function () {
  // console.log(document.referrer);
  var $this = $(this);
  if ($this.hasClass("close")) {
    var basePath = window.location.pathname.split("/");
    basePath.pop();
    var resetLink = basePath.join("/");
    window.location = resetLink;
  } else {
    history.back();
    var modal = document.getElementById("productModal");
    var drWrap = document.querySelectorAll(".doctor-pg-wrap")[0];
    drWrap.classList.remove("hide");
    modal.classList.remove("show");
  }

}

var addEventListeners = function () {
  $(".modal-button").on("click", loadAndshowModal);
  // add modal close event listener
  var backBtn = document.querySelectorAll(".back-btn")[0];
  if(backBtn){
    backBtn.addEventListener("click", backButtonClick);
  }
}

var updateState = function (data) {
  if (data == null) {
    hideModal();
  } else {
    var activeProduct = data.urlPath.split("/").pop();
    var btn = $("[data-handle=" + activeProduct + "]");
    if (btn.length > 0) {
      btn.click();
    }
  }
}

// Revert to a previously saved state
window.addEventListener("popstate", function (event) {
  updateState(event.state);
});

var initPage = function() {
  setOverWriteCookie();
  getProductJsonFromPage();
  addEventListeners();
}

document.addEventListener("DOMContentLoaded", initPage);

// direct to product add to cart screen
var checkURLForActiveProduct = function () {
  var url = [location.protocol, '//', location.host, location.pathname].join('');
  var possibleProductHandle = url.split("/").pop();
  var btn = $("[data-handle=" + possibleProductHandle + "]");
  if (btn.length > 0) {
    $("#productModal").find(".back-btn").addClass("close");
    btn.click();
  }
};

document.addEventListener("DOMContentLoaded", checkURLForActiveProduct);

//form_type=product&utf8=%E2%9C%93&properties%5Bshipping_interval_unit_type%5D=Months&id="+ productInfo.subscription_id +"&purchase_type=autodeliver&properties%5Bshipping_interval_frequency%5D=1&quantity=1
